module.exports = __webpack_public_path__ + "static/facebook-stock-price-increasing-3e5d59ce9778d01349d1b18dc9038cc8.png";